export const setNext =
  <TId>(next: TId | null) =>
  () =>
    next;
